module.exports = ".footer {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n}"